import { type ReactNode, type ComponentPropsWithoutRef } from 'react';
import cx from 'clsx';
import { Illustration } from './illustration';
import styles from './q-state.module.css';

function QState({
  children,
  className = '',
  ...props
}: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
    </div>
  );
}

function ActionsContainer({ children, ...props }: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className={styles.actions} {...props}>
      {children}
    </div>
  );
}

function LegendContainer({ children, ...props }: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className="body-2" {...props}>
      {children}
    </div>
  );
}

function TitleContainer({ children, ...props }: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className={cx('title-2', styles.title)} {...props}>
      {children}
    </div>
  );
}

const QStateComponent = Object.assign(QState, {
  Illustration,
  Title: TitleContainer,
  Legend: LegendContainer,
  Actions: ActionsContainer,
});

export { QStateComponent as QState };
